<template>
  <div class="space-y-2 p-4">
    <viewTitle title="业务管理 / 过磅确认管理 / 查看" :showReturn="true">
      <template slot="return">
        <el-button
          class="w-20"
          @click="$router.go(-1)"
          plain
          size="small"
          style="font-size: 14px;"
          >返回</el-button
        >
        <el-button
          v-if="detail.push_sap_state == 1 || detail.push_sap_state == 3"
          @click="onCloseBusiness"
          v-has="['c-pound-record-close']"
          size="small"
          type="danger"
          >人工关闭</el-button
        >
        <el-button
          v-if="detail.push_sap_state == 1 || detail.push_sap_state == 3"
          @click="onPushSap"
          size="small"
          v-has="['c-pound-record-sap']"
          type="primary"
          >传输SAP</el-button
        >
        <el-button
          v-if="
            (detail.push_sap_state == 2) &&
              (detail.push_pound_state == 1 || detail.push_pound_state == 3)
          "
          @click="onPushPound"
          size="small"
          v-has="['c-pound-record-pound']"
          type="primary"
          >推送地磅</el-button
        >
      </template>
    </viewTitle>
    <el-row>
      <el-col :span="12">
        <el-form :model="detail" label-position="left" class="detail_form">
          <div class="text-lg">地磅信息</div>
          <el-form-item label="所属基地">
            <span class="text-gray-500">{{ baseInfo.com_name || "--" }}</span>
          </el-form-item>
          <el-form-item label="门岗">
            <span class="text-gray-500">{{ detail.door_name || "--" }}</span>
          </el-form-item>
          <el-form-item label="地磅称台号">
            <span class="text-gray-500">{{
              detail.weighbridge_code || "--"
            }}</span>
          </el-form-item>
          <el-form-item label="过磅类型">
            <span class="text-gray-500">{{
              detail.weight_type | stateFormat(weightType)
            }}</span>
          </el-form-item>
          <el-form-item label="预约号">
            <span class="text-gray-500">{{ detail.booking_code || "--" }}</span>
          </el-form-item>
          <el-form-item label="订单号">
            <span class="text-gray-500">{{ detail.order_code || "--" }}</span>
          </el-form-item>
          <el-form-item label="车牌号">
            <span class="text-gray-500">{{
              detail.license_plate || "--"
            }}</span>
          </el-form-item>
          <el-form-item label="重量">
            <span class="text-gray-500">{{
              detail.weight ? `${detail.weight}T` : "--"
            }}</span>
          </el-form-item>
          <el-form-item label="过磅时间">
            <span class="text-gray-500">{{
              detail.weighing_time | timeFormat
            }}</span>
          </el-form-item>
          <el-form-item label="创建时间">
            <span class="text-gray-500">{{
              detail.create_time | timeFormat
            }}</span>
          </el-form-item>
          <div class="text-lg">同步SAP信息</div>
          <el-form-item label="SAP传输状态">
            <span class="text-gray-500">{{
              detail.push_sap_state | stateFormat(pushState)
            }}</span>
          </el-form-item>
          <el-form-item label="最近传输时间" v-if="detail.push_sap_time">
            <span class="text-gray-500">{{
              detail.push_sap_time | timeFormat
            }}</span>
          </el-form-item>
          <el-form-item label="失败传输原因" v-if="detail.push_sap_msg">
            <span class="text-gray-500">{{ detail.push_sap_msg || "--" }}</span>
          </el-form-item>
          <el-form-item label="磅单号" v-if="detail.pound_code">
            <span class="text-gray-500">{{ detail.pound_code || "--" }}</span>
          </el-form-item>
          <template v-if="detail.order_type === 'IB'">
            <el-form-item label="采购订单行项目">
              <span class="text-gray-500">{{ detail.order_item || "--" }}</span>
            </el-form-item>
            <el-form-item label="包数">
              <span class="text-gray-500">
                {{
                  detail.package_count === "" || detail.package_count === null || detail.package_count === undefined
                    ? "--"
                    : detail.package_count
                }}
              </span>
            </el-form-item>
            <el-form-item label="大小包">
              <span class="text-gray-500">{{ detail.is_small_package === "X" ? "小包" : "大包" }}</span>
            </el-form-item>
            <el-form-item label="承运商类型">
              <span class="text-gray-500">
                {{
                  detail.carrier_type === "0"
                    ? "外协车"
                    : detail.carrier_type === "1"
                    ? "财运满"
                    : "--"
                }}
              </span>
            </el-form-item>
          </template>
          <el-form-item label="关闭原因" v-if="detail.close_reason">
            <span class="text-gray-500">{{ detail.close_reason || "--" }}</span>
          </el-form-item>
          <div class="text-lg">推送地磅信息</div>
          <el-form-item label="地磅推送状态">
            <span class="text-gray-500">{{
              detail.push_pound_state | stateFormat(pushState)
            }}</span>
          </el-form-item>
          <el-form-item label="最近推送时间" v-if="detail.push_pound_time">
            <span class="text-gray-500">{{
              detail.push_pound_time | timeFormat
            }}</span>
          </el-form-item>
          <el-form-item label="推送失败原因" v-if="detail.push_pound_msg">
            <span class="text-gray-500">{{
              detail.push_pound_msg || "--"
            }}</span>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12" v-if="[1,2,3].includes(detail.booking_queue && detail.booking_queue.access_card_state)">
        <el-form :model="detail.booking_queue" label-position="left" class="detail_form">
          <div class="text-lg">发卡退卡信息</div>
          <el-form-item label="发卡状态">
            <span class="text-gray-500">{{ detail.booking_queue.access_card_state|formatAccessCardState }}</span>
          </el-form-item>
          <el-form-item label="门禁卡ID">
            <span class="text-gray-500">{{ detail.booking_queue.access_card_code }}</span>
          </el-form-item>
          <el-form-item label="发卡人">
            <span class="text-gray-500">{{ detail.booking_queue.access_card_send_user_name }}</span>
          </el-form-item>
          <el-form-item label="发卡时间">
            <span class="text-gray-500">{{ detail.booking_queue.access_card_send_time|timeFormat }}</span>
          </el-form-item>
          <el-form-item label="退卡人" v-if="detail.booking_queue.access_card_return_user_name">
            <span class="text-gray-500">{{ detail.booking_queue.access_card_return_user_name }}</span>
          </el-form-item>
          <el-form-item label="退卡时间" v-if="detail.booking_queue.access_card_return_time">
            <span class="text-gray-500">{{ detail.booking_queue.access_card_return_time|timeFormat }}</span>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <push-sap ref="pushSap" @ok="getDetail" />
    <closeBusiness ref="closeBusiness" @ok="getDetail" />
    <pushSapLeave ref="pushSapLeave" @ok="getDetail"/>
  </div>
</template>

<script>
import pushSap from "./components/pushSap.vue";
import closeBusiness from "./components/closeBusiness.vue";
import pushSapLeave from './components/pushSapLeave.vue';
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      labelWidth: "140px",
      detail: {
        booking_queue: {}
      },
      pushState: {
        1: "未传输",
        2: "已传输",
        3: "传输失败",
        4: "人工关闭",
        5: "系统关闭"
      },
      weightType: {
        1: "过磅进厂",
        2: "过磅出厂"
      }
    };
  },
  components: {
    pushSap,
    closeBusiness,
    pushSapLeave
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  methods: {
    getDetail() {
      this.$common
        .http({
          url: "/api/queue/admin/detail_booking_pound",
          data: { id: this.$route.params.id }
        })
        .then(res => {
          this.detail = res.data.data;
        });
    },
    onCloseBusiness(row) {
      this.$refs.closeBusiness.onOpen(this.detail);
    },
    onPushPound() {
      this.$confirm("确认推送地磅系统吗？", "提示").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/push_pound",
            data: {
              id: this.detail.id
            }
          });
          this.$message.success("地磅数据已发送");
          this.getDetail();
        } catch (error) {}
      });
    },
    async onPushSap() {
      const { weight_type, booking_state } = this.detail;
      if (weight_type == 1) {
        // 关键步骤：进厂 SAP 弹窗改为直接吃详情对象，避免国废扩展字段在这里被截断。
        this.$refs.pushSap.onOpen(this.detail);
      } else {
        if (booking_state != 46) {
          this.$alert("该记录不是待出厂状态，不能传输SAP！", "过磅出厂传输SAP确认", {
            showCancelButton: true,
            showConfirmButton: false
          })
          return;
        }
        this.$refs.pushSapLeave.onOpen(this.detail);
      }
    }
  },
  filters: {
    timeFormat(time, style = "YYYY-MM-DD HH:mm:ss") {
      return time ? moment.unix(time).format(style) : "--";
    },
    stateFormat(value, mapState) {
      return mapState[value] || "--";
    },
    formatAccessCardState(value) {
      return value == 1 ? '未发卡' : value == 2 ? '已发卡' : value == 3 ? '已退卡' : '--';
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common";
/deep/ .el-form-item {
  padding-left: 50px;
}
</style>
